/* ============================================================
   JMO PDP Pack Tiers — restricts qty to allow-listed tiers
   ============================================================
   - Selecting a tier writes its integer qty into input[name="quantity"]
   - Updates a summary line ("Selected: 5-pack — $74.95")
   - For tier blocks marked force_quote=true, the click on the quote
     button opens the existing quote drawer with the variant + tier qty
   - Bails early if no [data-jmo-pack-tiers] element is in the DOM
     (standard pricing mode automatically gets no behavior)
   ============================================================ */
(function () {
  if (window.__jmoPackTiersInit) return;
  window.__jmoPackTiersInit = true;

  function init() {
    var root = document.querySelector('[data-jmo-pack-tiers]');
    if (!root) return; // Standard mode — section not rendered

    var qtyInput = document.querySelector('input[name="quantity"]');
    var summaryEl = root.querySelector('[data-jmo-pack-summary]');
    var allocator = document.querySelector('[data-jmo-allocator]');
    var allocatorTarget = 0;

    function fmtMoney(n) {
      // Two-decimal display; no currency symbol prefix because we add $ in the template
      return Number(n).toFixed(2);
    }

    function applyTier(tierEl) {
      if (!tierEl) return;
      var customInput = tierEl.querySelector('[data-jmo-custom-qty]');
      var qty;
      var price;
      var label = tierEl.getAttribute('data-tier-label') || '';
      var isQuoteTier = tierEl.getAttribute('data-tier-force-quote') === 'true';

      // Pull the configured step for custom-qty tiers (default 1 = no step constraint).
      // Used to append "(in Ns)" to the summary so customers see the increment rule
      // even when they're focused on the summary line below the tier list.
      var step = 1;
      if (customInput) {
        // Custom-qty tier: pull qty from the input, compute price = qty * per_spool
        qty = parseInt(customInput.value, 10) || parseInt(customInput.getAttribute('data-min'), 10);
        step = parseInt(customInput.getAttribute('data-step'), 10) || 1;
        var perSpool = parseFloat(customInput.getAttribute('data-per-spool')) || 0;
        price = qty * perSpool;
        // Update the visible total in the pricing column
        var totalEl = tierEl.querySelector('[data-jmo-custom-total]');
        if (totalEl) {
          // For quote tiers, show "Quoted" instead of a misleading $0 total
          totalEl.textContent = isQuoteTier ? 'Quoted' : ('$' + fmtMoney(price) + ' total');
        }
      } else {
        qty = parseInt(tierEl.getAttribute('data-tier-qty'), 10);
        price = parseFloat(tierEl.getAttribute('data-tier-price')) || 0;
      }

      if (!qty || qty < 1) return;
      if (!label) label = qty + (qty === 1 ? ' spool' : ' spools');

      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Step suffix — only shown when the tier enforces a step > 1 (i.e., the 55+ B2B tier with step=5)
      var stepSuffix = step > 1 ? ' — quantity in increments of ' + step : '';

      if (summaryEl) {
        if (isQuoteTier) {
          summaryEl.textContent = 'Selected: ' + label + ' (' + qty + ') — pricing on quote' + stepSuffix;
        } else if (price > 0) {
          summaryEl.textContent = 'Selected: ' + label + ' (' + qty + ') — $' + fmtMoney(price) + stepSuffix;
        } else {
          summaryEl.textContent = 'Selected: ' + label + stepSuffix;
        }
      }

      // Quote-tier mode: hide ATC entirely, promote the Request Quote button to primary action
      var atcWrap = document.querySelector('.jmo-pdp__atc-wrap');
      var qtyWrap = document.querySelector('.jmo-pdp__qty');
      var rfqBtn = document.querySelector('.jmo-pdp__atq');
      if (atcWrap) atcWrap.classList.toggle('jmo-pdp__atc-wrap--hidden', isQuoteTier);
      if (qtyWrap) qtyWrap.classList.toggle('jmo-pdp__qty--hidden', isQuoteTier);
      if (rfqBtn) {
        rfqBtn.classList.toggle('jmo-pdp__atq--primary', isQuoteTier);
        // Tell the click handler to use allocator-driven submit when quote tier is selected
        rfqBtn.setAttribute('data-jmo-atq-mode', isQuoteTier ? 'submit' : 'open');
      }

      // Sync allocator target qty (visible only when tier > 1)
      syncAllocator(qty);

      // Notify the ATC button (in main-product.liquid) that the pack state changed
      document.dispatchEvent(new CustomEvent('jmo:pack:changed', { detail: { qty: qty, isQuoteTier: isQuoteTier } }));
    }

    /* ----- Allocator: distribute pack qty across color variants -----
       Shown for ALL tiers (including 1-spool) so the customer chooses
       the color(s) via the allocator instead of relying on whatever
       variant happens to be in the URL/variant selector. */
    function syncAllocator(targetQty) {
      if (!allocator) return;
      allocatorTarget = targetQty || 0;

      // Hide only when target is 0 (shouldn't happen in practice)
      if (allocatorTarget < 1) {
        allocator.hidden = true;
        clearAllocator();
        return;
      }
      allocator.hidden = false;

      // Update target label
      var targetEl = allocator.querySelector('[data-jmo-allocator-target]');
      if (targetEl) targetEl.textContent = allocatorTarget;

      // Adaptive heading + status unit based on target qty
      var headingEl = allocator.querySelector('[data-jmo-allocator-heading]');
      var unitEl = allocator.querySelector('[data-jmo-allocator-status-unit]');
      if (allocatorTarget === 1) {
        if (headingEl) headingEl.textContent = 'Pick Your Color';
        if (unitEl) unitEl.textContent = 'spool selected';
      } else {
        if (headingEl) headingEl.textContent = 'Pick Your Colors';
        if (unitEl) unitEl.textContent = 'spools selected';
      }

      // Clamp any existing values that exceed the new target
      var sum = sumAllocator();
      if (sum > allocatorTarget) {
        // Trim from the last input downward until sum matches
        var inputs = Array.from(allocator.querySelectorAll('[data-jmo-allocator-qty]'));
        for (var i = inputs.length - 1; i >= 0 && sum > allocatorTarget; i--) {
          var v = parseInt(inputs[i].value, 10) || 0;
          var over = sum - allocatorTarget;
          var trim = Math.min(v, over);
          inputs[i].value = v - trim;
          sum -= trim;
        }
      }
      // Intentionally do NOT auto-distribute on a fresh tier pick — the customer must
      // actively pick colors themselves. The "0 of N spools allocated" status is the
      // desired starting state; the ATC button validation surfaces a clear message if
      // they try to add to cart without finishing the allocation.
      updateAllocatorStatus();
    }

    function sumAllocator() {
      if (!allocator) return 0;
      var total = 0;
      allocator.querySelectorAll('[data-jmo-allocator-qty]').forEach(function (input) {
        total += parseInt(input.value, 10) || 0;
      });
      return total;
    }

    function updateAllocatorStatus() {
      if (!allocator) return;
      var sum = sumAllocator();
      var currentEl = allocator.querySelector('[data-jmo-allocator-current]');
      if (currentEl) currentEl.textContent = sum;
      allocator.classList.toggle('is-complete', sum === allocatorTarget);
      allocator.classList.toggle('is-over', sum > allocatorTarget);
      // Notify ATC button so it can swap label between ADD/UPDATE/CHECKOUT states
      document.dispatchEvent(new CustomEvent('jmo:pack:changed', { detail: { allocatorSum: sum } }));
    }

    function clearAllocator() {
      if (!allocator) return;
      allocator.querySelectorAll('[data-jmo-allocator-qty]').forEach(function (i) { i.value = 0; });
      updateAllocatorStatus();
    }

    function distributeEvenly() {
      if (!allocator || allocatorTarget < 1) return;
      // Auto-distribute only across IN-STOCK colors. Sold-out colors stay at 0 here so
      // the default state is cart-eligible; users can still manually allocate to sold-out
      // colors via the stepper to request a quote.
      var inputs = Array.from(allocator.querySelectorAll('[data-jmo-allocator-qty]'))
        .filter(function (i) {
          var row = i.closest('.jmo-pdp-allocator__row');
          return row && row.getAttribute('data-variant-available') === 'true';
        });
      if (inputs.length === 0) return;
      var base = Math.floor(allocatorTarget / inputs.length);
      var remainder = allocatorTarget - (base * inputs.length);
      inputs.forEach(function (input, idx) {
        input.value = base + (idx < remainder ? 1 : 0);
      });
      updateAllocatorStatus();
    }

    // Sync the top variant selector + main gallery image to the variant in `rowEl`.
    // Called whenever the customer interacts with a specific allocator row (swatch, name,
    // stepper +/-, or qty input) so the top picker always reflects the "current focus" color.
    function syncTopVariantFromRow(rowEl) {
      if (!rowEl) return;
      var variantId = rowEl.getAttribute('data-variant-id');
      if (!variantId) return;
      try {
        var pj = document.querySelector('[data-jmo-product-json]');
        if (!pj) return;
        var variants = JSON.parse(pj.textContent);
        var v = variants.find(function (x) { return String(x.id) === String(variantId); });
        if (!v) return;
        var targetRadios = document.querySelectorAll('[data-jmo-option-input]');
        for (var i = 0; i < targetRadios.length; i++) {
          if (targetRadios[i].value === v.option1) {
            if (!targetRadios[i].checked) {
              targetRadios[i].checked = true;
              targetRadios[i].dispatchEvent(new Event('change', { bubbles: true }));
            }
            break;
          }
        }
      } catch (err) { /* ignore */ }
    }

    if (allocator) {
      // Click the swatch image or color name in an allocator row → preview that variant
      // in the main gallery image AND sync the top variant selector radio. This lets B2B
      // customers eyeball colors without leaving the allocator UI.
      allocator.addEventListener('click', function (e) {
        var swatch = e.target.closest('.jmo-pdp-allocator__swatch, .jmo-pdp-allocator__name');
        if (swatch) {
          syncTopVariantFromRow(swatch.closest('[data-variant-id]'));
          return;
        }

        var stepBtn = e.target.closest('[data-jmo-allocator-step]');
        if (stepBtn) {
          e.preventDefault();
          var row = stepBtn.closest('.jmo-pdp-allocator__row');
          var input = row && row.querySelector('[data-jmo-allocator-qty]');
          if (!input) return;
          var step = parseInt(stepBtn.getAttribute('data-jmo-allocator-step'), 10);
          var current = parseInt(input.value, 10) || 0;
          var next = current + step;
          if (next < 0) next = 0;
          // Cap at allocatorTarget minus the sum of OTHER inputs (don't exceed target)
          var sum = sumAllocator();
          var maxForThis = current + (allocatorTarget - sum);
          var wasCapped = false;
          if (next > maxForThis) { next = maxForThis; wasCapped = true; }
          if (next < 0) next = 0;
          input.value = next;
          if (wasCapped && step > 0 && next === current) {
            // User pressed + but pack is already at target — surface a brief inline hint right under THIS row
            showAllocatorHint(row);
          }
          // Sync top variant to the row the customer just interacted with
          syncTopVariantFromRow(row);
          updateAllocatorStatus();
          return;
        }
        if (e.target.closest('[data-jmo-allocator-distribute]')) {
          e.preventDefault();
          distributeEvenly();
          return;
        }
        if (e.target.closest('[data-jmo-allocator-clear]')) {
          e.preventDefault();
          clearAllocator();
          return;
        }
      });
      allocator.addEventListener('change', function (e) {
        var input = e.target.closest('[data-jmo-allocator-qty]');
        if (!input) return;
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        // Don't allow this single input to push total above target
        var other = sumAllocator() - (parseInt(input.value, 10) || 0);
        var wasCapped = false;
        if (val + other > allocatorTarget) { val = allocatorTarget - other; wasCapped = true; }
        input.value = val;
        if (wasCapped) {
          showAllocatorHint(input.closest('.jmo-pdp-allocator__row'));
        }
        // Sync top variant to the row whose qty just changed
        syncTopVariantFromRow(input.closest('.jmo-pdp-allocator__row'));
        updateAllocatorStatus();
      });

      // Inline "pack is full" hint — single shared element that gets re-parented under whichever
      // variant row triggered it. Auto-dismisses after a short window so the customer always sees
      // the feedback right where they tapped (important on mobile where the row may scroll off-screen).
      var hintEl = document.createElement('div');
      hintEl.className = 'jmo-pdp-allocator__hint';
      hintEl.setAttribute('role', 'status');
      hintEl.setAttribute('aria-live', 'polite');
      hintEl.hidden = true;
      hintEl.innerHTML = '<span class="jmo-pdp-allocator__hint-icon" aria-hidden="true">&#9888;</span><span class="jmo-pdp-allocator__hint-text">Pack is full. Reduce another color or pick a larger pack size to add more.</span>';
      var hintTimer = null;
      function showAllocatorHint(rowEl) {
        if (!rowEl) return;
        // Re-parent so the hint always sits directly under the affected row
        if (rowEl.nextSibling !== hintEl) rowEl.parentNode.insertBefore(hintEl, rowEl.nextSibling);
        hintEl.hidden = false;
        // Reset CSS animation by toggling a class
        hintEl.classList.remove('is-visible');
        // Force reflow so the next class addition retriggers the fade-in
        void hintEl.offsetWidth;
        hintEl.classList.add('is-visible');
        if (hintTimer) clearTimeout(hintTimer);
        hintTimer = setTimeout(function () {
          hintEl.classList.remove('is-visible');
          // After the fade-out animation completes, fully hide the element
          setTimeout(function () { hintEl.hidden = true; }, 250);
        }, 6000);
      }
    }

    function clampStep(val, min, max, step) {
      if (val < min) val = min;
      if (val > max) val = max;
      // Snap to nearest step above min
      var offset = (val - min) % step;
      if (offset !== 0) val = val - offset;
      return val;
    }

    // Custom-qty input change → recompute + apply
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-jmo-custom-qty]');
      if (!input) return;
      var tierEl = input.closest('[data-jmo-tier]');
      if (!tierEl) return;
      var min = parseInt(input.getAttribute('data-min'), 10) || 1;
      var max = parseInt(input.getAttribute('data-max'), 10) || 9999;
      var step = parseInt(input.getAttribute('data-step'), 10) || 1;
      var val = clampStep(parseInt(input.value, 10) || min, min, max, step);
      input.value = val;
      var radio = tierEl.querySelector('.jmo-pdp-tier__radio');
      if (radio && !radio.checked) radio.checked = true;
      applyTier(tierEl);
    });

    // Intercept the RFQ button click ALWAYS — route through the form's submit handler so the
    // allocator validation runs and items get pushed to the quote drawer. The submit handler
    // reads window.__jmoQuoteSubmitFromRfq to know this came from the RFQ button (force quote
    // routing regardless of which tier is selected).
    // Capture-phase + stopPropagation prevents the global [data-jmo-quote-open] handler
    // (in jmo-quote.js) from also firing.
    var rfqBtn = document.querySelector('.jmo-pdp__atq');
    if (rfqBtn) {
      rfqBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var form = document.querySelector('.jmo-pdp__form');
        if (!form) return;
        window.__jmoQuoteSubmitFromRfq = true;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }, true);
    }

    // Custom-qty stepper buttons
    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-jmo-custom-step]');
      if (!stepBtn) return;
      e.preventDefault();
      var tierEl = stepBtn.closest('[data-jmo-tier]');
      if (!tierEl) return;
      var input = tierEl.querySelector('[data-jmo-custom-qty]');
      if (!input) return;
      var direction = parseInt(stepBtn.getAttribute('data-jmo-custom-step'), 10);
      var min = parseInt(input.getAttribute('data-min'), 10) || 1;
      var max = parseInt(input.getAttribute('data-max'), 10) || 9999;
      var step = parseInt(input.getAttribute('data-step'), 10) || 1;
      var current = parseInt(input.value, 10) || min;
      var next = clampStep(current + (direction * step), min, max, step);
      input.value = next;
      var radio = tierEl.querySelector('.jmo-pdp-tier__radio');
      if (radio && !radio.checked) radio.checked = true;
      applyTier(tierEl);
    });

    // Edit Pack flow: if ?edit_pack=1 + sessionStorage snapshot exists, pre-fill tier + allocator
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('edit_pack') === '1') {
        var raw = sessionStorage.getItem('jmoEditPack');
        if (raw) {
          var snap = JSON.parse(raw);
          // Pick the matching tier by quantity (or the custom tier if qty doesn't match any fixed tier)
          var packTotal = parseInt(snap.packTotal, 10);
          var tierEls = root.querySelectorAll('[data-jmo-tier]');
          var matchedTier = null;
          // First try exact quantity match on non-custom tiers
          tierEls.forEach(function (tEl) {
            if (matchedTier) return;
            if (tEl.getAttribute('data-tier-force-quote') === 'true') return;
            var tQty = parseInt(tEl.getAttribute('data-tier-qty'), 10);
            var hasCustom = tEl.querySelector('[data-jmo-custom-qty]');
            if (!hasCustom && tQty === packTotal) matchedTier = tEl;
          });
          // Fallback: if no exact match, use the custom-qty tier and set its value
          if (!matchedTier) {
            tierEls.forEach(function (tEl) {
              if (matchedTier) return;
              if (tEl.querySelector('[data-jmo-custom-qty]')) matchedTier = tEl;
            });
            if (matchedTier) {
              var customInput = matchedTier.querySelector('[data-jmo-custom-qty]');
              if (customInput) customInput.value = packTotal;
            }
          }
          if (matchedTier) {
            var matchedRadio = matchedTier.querySelector('.jmo-pdp-tier__radio');
            if (matchedRadio) matchedRadio.checked = true;
            applyTier(matchedTier);
          }
          // Fill allocator with the snapshot allocation
          if (allocator && snap.allocation && snap.allocation.length > 0) {
            clearAllocator();
            snap.allocation.forEach(function (a) {
              var input = allocator.querySelector('[data-jmo-allocator-qty][data-variant-id="' + a.variantId + '"]');
              if (input) input.value = a.quantity;
            });
            updateAllocatorStatus();
          }
          sessionStorage.removeItem('jmoEditPack');
          // Clean the URL so refresh doesn't re-trigger
          if (window.history && window.history.replaceState) {
            params.delete('edit_pack');
            var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
            window.history.replaceState({}, '', clean);
          }
        }
      }
    } catch (e) {
      console.warn('[jmo-pack-tiers] edit-pack restore failed', e);
    }

    // Initial sync — apply whichever tier is already checked (first by default)
    var checked = root.querySelector('.jmo-pdp-tier__radio:checked');
    if (checked) {
      var tierEl = checked.closest('[data-jmo-tier]');
      applyTier(tierEl);
    }

    // Tier radio change → apply qty
    root.addEventListener('change', function (e) {
      var radio = e.target.closest('.jmo-pdp-tier__radio');
      if (!radio || !radio.checked) return;
      var tierEl = radio.closest('[data-jmo-tier]');
      applyTier(tierEl);
    });

    // Quote-tier button: write the tier qty to the qty input before the global
    // [data-jmo-quote-open] handler fires (so the PDP-quote integration captures
    // the correct quantity). The global handler reads input[name="quantity"].
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-jmo-quote-open]');
      if (!btn) return;
      var tierEl = btn.closest('[data-jmo-tier]');
      if (!tierEl) return;
      var qty = parseInt(tierEl.getAttribute('data-tier-qty'), 10);
      if (qtyInput && qty >= 1) {
        qtyInput.value = qty;
      }
      // Don't preventDefault — let the global quote-open handler run
    }, true); // capture phase so we set qty before the global click listener

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
